// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"ba2e1327","453":"ef065ad0","945":"c1d668c0"}[chunkId] + ".chunk.js";
};